import { render, staticRenderFns } from "./ResourceTimeSlotsItem.vue?vue&type=template&id=e2357932&scoped=true"
import script from "./ResourceTimeSlotsItem.vue?vue&type=script&lang=js"
export * from "./ResourceTimeSlotsItem.vue?vue&type=script&lang=js"
import style0 from "./ResourceTimeSlotsItem.vue?vue&type=style&index=0&id=e2357932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2357932",
  null
  
)

export default component.exports